import {
  Type,
  Status as StatusOrder,
  ServiceType,
  ParcelType,
  InsuranceType,
  PostOrderStatusType,
  Order3PLStatusType,
  CodType,
} from '../pages/orders/interfaces';
import {
  DriverDeliverStatus,
  OrderBundleStatus,
  Status as StatusBundle,
} from '../pages/bundles/interfaces';
import {EmploymentStatus, EmploymentType} from '../pages/drivers/interfaces';
import {UserRole} from '../pages/users/interfaces';
import {Status as StatusCenter} from '../pages/centers/interfaces';
import {
  Type as FleetType,
  Status as FleetStatus,
  SettlementType,
  VehicleType,
} from '../pages/fleets/interfaces';
import {
  Status as StatusParcels,
  ItemsStatus as ItemsStatusParcels,
} from '../pages/parcels/interfaces';
import {Status as ItemsStatusInventory} from '../pages/warehouseInventory/interfaces';
import {isArray} from 'util';
import {WebhookType} from '../pages/webhooks/interfaces';
import jMoment from 'moment-jalaali';

export type OrderTransportationType =
  | 'NONE'
  | 'LINK_EXPRESS'
  | 'ALOPEYK'
  | 'TAROFF'
  | 'CHAPAR'
  | 'PETROEX'
  | 'TAPIN_POST'
  | 'TAPIN_KETAB'
  | 'NEDEX';

enum dictionaryKey {
  common,
  order,
  TPL,
  tplStatus,
  driver,
  service,
  parcel,
  insurance,
  inventory,
  bundle,
  fleet,
  user,
  center,
  ticket,
  cod,
  invoice,
  cancelTask
}

export type dictionaryKeyStrings = keyof typeof dictionaryKey;
const dictionary = {
  common: {
    WEEKLY: 'هفتگی',
    MONTHLY: 'ماهانه',
    DAILY: 'روزانه',
    YEARLY: 'سالانه',
    BOX: 'کارتن',
    PALLET: 'پالت',
    BULK: 'فله',
    CHARGE: 'شارژ',
    INCREASE: 'افزایش',
    DECREASE: 'کاهش',
    SETTLE: 'تسویه',
    UPDATE_ORDER_STATUS: 'سرویس تغییر وضعیت سفارش',
    UPDATE_PARCEL_STATUS: 'سرویس تغییر وضعیت محموله',
    COURIER: 'پیک',
    POST: 'پست',
    EXPRESS_POST: 'پست پیشتاز',
    SPECIAL_POST: 'پست سفارشی',
    VIP: 'ارسال ویژه',
    PART_TIME: 'پاره وقت',
    FULL_TIME: 'تمام وقت',
    CAR: 'سواری',
    MOTORCYCLE: 'موتوری',
    PICKUPS: 'وانت',
    TRUCK: 'خاور',
    HEAVY_TRUCK: 'کامیون',
    AIRPLANE: 'هواپیما',
    INBOUND: 'محموله',
    OUTBOUND: 'سفارش',
    DELIVERY: 'ارسال',
    ALL: 'همه',
    'CHAPAR,COURIER': 'هردو',
    CHAPAR: 'چاپار',
    DELIVER_IN_RONAD: 'تحویل در انبار',
    order: 'سفارش',
    parcel: 'محموله'
  },
  order: {
    ARRIVED: 'به مقصد رسیده',
    BUNDLED: ' بسته‌بندی شده برای راننده',
    CANCELLED: 'لغو شده',
    DELIVERED_TO_POST: 'ارسال به پست',
    DELIVERING_TO_POST: 'در حال ارسال به پست',
    DELIVERED_TO_CENTER: 'تحویل به مرکز',
    SUPPLIED_IN_CENTER: 'تامین در مرکز',
    DELIVERED_TO_COURIER: 'تحویل پیک شد',
    PACKAGED: 'بسته بندی شده برای مشتری',
    PICKED: 'برداشته شده',
    DELIVERED: 'تحویل به مشتری',
    LOADED: 'در حال تحویل',
    NOT_DELIVERED: 'تحویل داده نشده',
    PROCESSING: 'در حال پردازش',
    PROCESSED: 'پردازش شده',
    ORDERED: 'ایجاد شده',
    RETURNED: 'بازگردانده شده',
    ASSIGNED: 'تخصیص شده',
    REGISTERED_IN_3PL: 'درحال ارسال',
    REGISTERING_IN_3PL: 'درحال ارسال',
    DELIVERING: 'درحال ارسال',
    DELIVERED_TO_3PL: 'درحال ارسال',
    DELIVERED_TO_3PL_COURIER: 'درحال ارسال',
    CANCELED_FROM_3PL: 'درحال ارسال',
    AWAITING_REVIEW: 'درحال ارسال',
    SUPPLYING: 'در انتظار تامین موجودی',
    DONE: 'ارسال به پست',
    QUEUE: 'آماده ارسال',
    DRAFT: 'ارسال نشده',
    true: 'باندل شده',
    false: 'باندل نشده',
    REQUESTED_TO_RETURN: 'درخواست بازگشت به انبار',
    RETURNED_TO_WAREHOUSE: 'بازگشت به انبار',
    REQUESTED_TO_RESEND: 'درخواست ارسال مجدد',
    SCANNED: 'اسکن شده',
    CONFIRMED: 'تایید شده',
    REGISTERED: 'ثبت در سیستم',
    AWAITING_PAYMENT: 'در انتظار پرداخت',
    CANCELED: 'کنسل شده',
    FROM_CENTER: 'مرکز توزیع به مشتری',
    WITHOUT_CENTER: 'انبار به مشتری',
    SUBMITTED: 'ایجاد شده',
    SHIPPED: ' ارسال شده',
    RETURNING: 'ریجکت شده',
    UNLOADING: 'درحال پردازش',
    UNLOADED: 'تخلیه شده',
    CONFLICTED: 'مغایرت',
    LOCATED: 'جایگذاری شده',
    NOT_REGISTERED: 'ایجاد شده (رجیستر نشده)',
    CHECKED: 'بسته‌بندی شده',
    '09:00:00': 'صبح',
    '15:00:00': 'بعدازظهر',
    IN_CUSTOMER_ADDRESS: 'تحویل در ادرس مشتری',
    IN_RONAD: 'تحویل درب انبار روناد',
  },
  TPL: {
    NONE: 'بدون 3PL',
    ALOPEYK: 'الوپیک',
    LINK_EXPRESS: 'لینک اکسپرس',
    TAROFF: 'تعارف',
    CHAPAR: 'چاپار',
    PETROEX: 'پتروکس',
    PISHRO_POST: 'پیشرو پست',
    SPEED: 'اسپید',
    DTSXP: 'دی تی اس',
    TAPIN_POST: 'تاپین',
    TAPIN_KETAB: 'تاپین کتاب',
    NEDEX: 'ندکس',
  },
  ticket: {
    OPEN: ' باز',
    CLOSED: 'بسته',
    ATTENDEE_ANSWERED: 'پاسخ داده شد',
    ASSIGNEE_ANSWERED: 'پاسخ داده شد',
    PENDING: 'در انتظار پاسخ',
    OWNER_ANSWERED: 'پاسخ ایجادکننده',
    NON: 'ناشناخته',
    LOW: 'کم',
    NORMAL: 'متوسط',
    HIGH: 'زیاد',
    CRITICAL: 'اضطراری',
    FFC: 'روناد',
    PARTNER: 'پارتنر',
    SUPPORT_OPEN: 'نیازمند بررسی',
    SUPPORT_OWNER_ANSWERED: 'نیازمند بررسی',
    SUPPORT_ASSIGNEE_ANSWERED: 'در انتظار پاسخ مشتری',
    SUPPORT_PENDING: 'نیازمند بررسی',
    SUPPORT_CLOSED: 'بسته',
    PARTNER_OPEN: 'ایجاد شده',
    PARTNER_OWNER_ANSWERED: 'در انتظار پاسخ مشتری',
    PARTNER_ASSIGNEE_ANSWERED: 'نیازمند بررسی',
    PARTNER_PENDING: 'در انتظار پاسخ مشتری',
    PARTNER_CLOSED: 'بسته',
    FFC_OPEN: 'درحال بررسی تیم',
    FFC_OWNER_ANSWERED: 'درحال بررسی تیم',
    FFC_ASSIGNEE_ANSWERED: 'درحال بررسی تیم',
    FFC_PENDING: 'درحال بررسی تیم',
    FFC_CLOSED: 'بسته',
  },
  tplStatus: {
    REJECTED_BY_3PL: 'رد شده توسط 3PL',
    REGISTERED_IN_3PL: 'ثبت شده در 3PL',
    SEARCHING_COURIER: 'جستجوی پیک',
    SEARCHING_COURIER_EXPIRED: 'جستجوی پیک منقضی شد',
    COURIER_ACCEPTED: 'پیک درخواست شما را پذیرفت',
    DELIVERED_TO_3PL: 'تحویل داده شده به 3PL ',
    DELIVERED_TO_3PL_COURIER: 'تحویل داده شده به پیک 3PL ',
    DELIVERED: 'تحویل داده شده',
    NOT_DELIVERED: 'تحویل داده نشده',
    CANCELLED: 'لغو شده',
    REQUESTED_TO_CANCEL: 'درخواست شده برای لغو',
    NOT_REGISTERED: 'ایجاد شده (رجیستر نشده)',
    NONE: 'هیچکدام',
  },
  driver: {
    REGISTERED: 'ثبت نام',
    OFF: 'غیر فعال',
    ACTIVE: 'فعال',
    SUSPENDED: 'معلق',
    DELIVERED: 'سفیر شما رسیده است',
    PICKING: 'در مسیر تحویل گرفتن سفارش',
    SEARCHING: 'در حال جست و جوی سفیر',
    ACCEPTED: 'سفیر شما تحویل بسته را پذیرفت',
    EXPIRED: 'درخواست سفیر ، منقضی شد',
    DELIVERING: 'بسته شما در مسیر تحویل دادن سفارش است',
    CANCELLED: 'سفر شما لغو شد',
    ENTERED: 'به مرکز رسیده',
    WAITING: 'در انتظار بارگیری',
    LOADED: 'بارگیری شده',
    EXITED: 'خارج شده',
  },
  service: {
    1: 'پیشتاز',
    2: 'سفارشی',
    3: 'ویژه',
  },
  parcel: {
    1: 'پاکت پیشتاز',
    2: 'بسته پیشتاز',
    3: 'پاکت سفارشی',
    4: 'بسته سفارشی',
    5: 'مطبوع',
    6: 'کیسه M',
    10: 'امانت',
    SUBMITTED: 'ایجاد شده',
    SHIPPED: ' ارسال شده',
    DELIVERED: ' تخلیه شده',
    CANCELLED: ' لغو شده',
    ASSIGNED: 'اختصاص داده شده',
    RETURNING: 'ریجکت شده',
    ARRIVED: 'به مقصد رسیده',
    UNLOADING: 'در حال بارگذاری',
    UNLOADED: 'تخلیه شده',
    CONFLICTED: 'مغایرت',
    REGISTERED: 'رجیستر شده',
    LOCATED: 'جایگذاری شده',
    PICKED: 'برداشته شده',
    NOT_REGISTERED: 'ایجاد شده (رجیستر نشده)',
    CHECKED: 'بسته‌بندی شده',
    RECEIPT_TO_WASTAGE: 'ورود به قرنطینه',
    RECEIPT_FROM_WASTAGE: 'خروج از قرنطینه',
    PACKAGED: 'بسته بندی شده',
    WASTED: 'قرنطینه',
    NORMAL: 'عادی',
    VIP: "ویژه",
    RESOLVED_BY_RONAD: "رفع مغایرت توسط روناد",
    LESS_THAN_SUBMITTED: "تعداد کم",
    PHYSICAL_CONFLICT: "مشکل فیزیکی",
  },
  insurance: {
    1: 'بیمه عادی',
    2: 'وجه نقد',
    3: 'اوراق و اسناد بانکی',
    4: 'بار انبوه',
    5: 'سایر',
  },
  inventory: {
    FROZEN: 'منجمد',
    FRUIT: 'میوه',
    GROCERY: 'خواربار',
    MEAT: 'گوشت',
    MASK: 'ماسک',
    PRODUCT: 'محصول',
    PICKED: 'برداشته شده',
    CHECKED: 'بررسی شده',
    NOT_REGISTERED: 'ایجاد شده (رجیستر نشده)',
    REGISTERED: 'رجیستر شده',
    LOCATED: 'جایگذاری شده',
    NOT_LOCATED: 'جاگذاری نشده',
    INBOUND: 'ورودی',
    PURCHASE: 'سفارش',
    OUTBOUND: 'خروجی',
    CURRENTLY: 'موجودی فعلی',
    OTHER: 'نامشخص',
    null: 'نامشخص',
  },
  bundle: {
    ASSIGNED: 'اختصاص داده شده',
    CANCELLED: 'لغو شده',
    CREATED: 'بسته ایجاد شده',
    LOADED: 'بارگیری شده',
    PROCESS_FAILED: 'ناموفق',
    PROCESS_STARTED: 'راننده در مسیر مرکز',
    PROCESSED: 'راننده تحویل داده',
    VEHICLE_ARRIVED: 'ماشین به مرکز رسیده',
    true: 'باندل شده',
    false: 'باندل نشده'
  },
  fleet: {
    PROPRIETARY: 'اختصاصی',
    THIRD_PARTY: 'عمومی',
    SUSPENDED: 'غیر فعال',
    ACTIVE: 'فعال',
  },
  user: {
    NONE: 'هیچکدام',
    RONAD_ADMIN: 'مدیر ارشد',
    PARTNER_ADMIN: 'ادمین شرکت',
    LOGISTICS_ADMIN: 'سرپرست لجستیک',
    WAREHOUSE_ADMIN: 'ادمین انبار',
    WAREHOUSE_OPERATOR: 'اپراتور انبار',
    WAREHOUSE_SUPERVISOR: 'سرپرست انبار',
    DRIVER: 'راننده',
    CENTER_ADMIN: 'ادمین مرکز',
    MARKETING_MANAGER: 'مدیر مارکتینگ',
    MARKETING_EXPERT: 'کارشناس مارکتینگ',
    OPERATIONS_MANAGER: 'مدیر عملیات',
    OPERATIONS_EXPERT: 'کارشناس عملیات',
    SUPPORT_MANAGER: 'مدیر پشتیبانی',
    SUPPORT_EXPERT: 'کارشناس پشتیبانی',
    AGENCY_ADMIN: 'نماینده',
    SELLER_ADMIN: 'ادمین فروشنده',
    FINANCIAL_SUPERVISOR: 'سرپرست مالی',
  },
  center: {
    ACTIVE: 'فعال',
    SUSPENDED: 'غیرفعال',
  },
  cod: {
    COD: 'در محل',
    ONLINE: 'آنلاین',
  },
  invoice: {
    CASH_PAID: 'تسویه دستی',
    CREATED: 'ایجاد شده',
    PAID: 'تسویه شده',
    NOT_PAID: 'تسویه نشده',
    CANCELLED: 'لغو شده'
    ,
  },
  cancelTask: {
    CREATED: 'ایجاد شده',
    DONE: 'جای گذاری شده',
    ASSIGNED: 'تخصیص شده',
  }
};

export const translate = (
  value: any,
  type: dictionaryKeyStrings = 'common'
) => {
  return dictionary[type][value] || value;
};

export function flattenObject(obj: {[key: string]: any}) {
  const toReturn = {} as {[key: string]: string};
  for (const i in obj) {
    if (!obj.hasOwnProperty(i) && i !== null) continue;

    if (isArray(obj[i])) {
      // convert Array to string with ','
      obj[i] = obj[i].join(',');
    }
    if (typeof obj[i] == 'object' && obj[i] !== null) {
      const flatObject = flattenObject(obj[i]);

      for (const x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;

        toReturn[i + '.' + x] = flatObject[x];
      }
    } else {
      toReturn[i] = obj[i];
    }
  }
  return toReturn;
}

export const packegeCounter = (packages: object[]) => {
  return packages.reduce((acc, curr) => {
    return acc + curr.count;
  }, 0);
};

export const UserRoles: UserRole[] = [
  'PARTNER_ADMIN',
  'RONAD_ADMIN',
  'MARKETING_MANAGER',
  'MARKETING_EXPERT',
  'OPERATIONS_MANAGER',
  'OPERATIONS_EXPERT',
  'SUPPORT_MANAGER',
  'SUPPORT_EXPERT',
  'WAREHOUSE_SUPERVISOR',
  'WAREHOUSE_ADMIN',
  'WAREHOUSE_OPERATOR',
  'AGENCY_ADMIN',
  'CENTER_ADMIN',
  'SELLER_ADMIN',
  'DRIVER',
  'LOGISTICS_ADMIN',
  'FINANCIAL_SUPERVISOR',
];

export const checkHourisPast = (hour: number, day: string): boolean => {
  if (
    convertPersianDigit2English(jMoment().format('YYYY-MM-DD')) === day ||
    convertPersianDigit2English(jMoment().format('YYYY-MM-DD')) ===
      convertPersianDigit2English(jMoment(day).format('YYYY-MM-DD'))
  ) {
    return convertPersianDigit2English(jMoment().format('HH')) >= hour;
  }
  return false;
};

export const disablePrevDateByHour = (hour: number) => {
  const today = new Date();
  if (today.getHours() >= hour) {
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
  } else {
    return today;
  }
};

export function convertPersianDigit2English(string: any) {
  return string
    .replace(/[\u0660-\u0669]/g, (c: string) => {
      return c.charCodeAt(0) - 0x0660;
    })
    .replace(/[\u06f0-\u06f9]/g, (c: string) => {
      return c.charCodeAt(0) - 0x06f0;
    });
}

export function translateCancelationTasksStatus(value: string) {
  const status = {
    CREATED: 'ایجاد شده',
    DONE: 'جای گذاری شده',
    ASSIGNED: 'تخصیص شده',
  };
  return status[value];
}

export function translateCodStatus(value: CodType) {
  const status = {
    COD: 'در محل',
    ONLINE: 'آنلاین',
  };
  return status[value];
}

export function numberWithCommas(x: any) {
  return x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const removeEmptyValueObject = (obj: any) => {
  Object.keys(obj).forEach(key => {
    if (
      // todo: it must be on filter form
      typeof obj[key]?.contains === 'string' &&
      obj[key].contains.substring(0, 1) === '0' &&
      key === 'phoneNumber'
    ) {
      obj[key].contains = obj[key].contains.replace('0', '98');
    }
    if (obj[key] && typeof obj[key] === 'object' && obj[key].length !== 0) {
      removeEmptyValueObject(obj[key]);
    }
    // recurse
    else if (obj[key] == null || obj[key] === '' || obj[key].length === 0)
      delete obj[key]; // delete
  });

  return obj;
};

export function translateOrderStatus(value: StatusOrder) {
  const status = {
    ARRIVED: 'به مقصد رسیده',
    BUNDLED: ' بسته‌بندی شده برای راننده',
    CANCELLED: 'لغو شده',
    DELIVERED_TO_POST: 'ارسال به پست',
    DELIVERING_TO_POST: 'در حال ارسال به پست',
    DELIVERED_TO_CENTER: 'تحویل به مرکز',
    SUPPLIED_IN_CENTER: 'تامین در مرکز',
    DELIVERED_TO_COURIER: 'تحویل پیک شد',
    PACKAGED: 'بسته بندی شده برای مشتری',
    PICKED: 'برداشته شده',
    DELIVERED: 'تحویل به مشتری',
    LOADED: 'در حال تحویل',
    NOT_DELIVERED: 'تحویل داده نشده',
    PROCESSING: 'در حال پردازش',
    PROCESSED: 'پردازش شده',
    ORDERED: 'ایجاد شده',
    RETURNED: 'بازگردانده شده',
    ASSIGNED: 'تخصیص شده',
    REGISTERED_IN_3PL: 'ثبت در 3PL',
    REGISTERING_IN_3PL: 'در حال ثبت روی 3PL',
    DELIVERING: 'در حال تحویل',
    DELIVERED_TO_3PL: 'تحویل به 3PL',
    DELIVERED_TO_3PL_COURIER: 'تحویل به پیک 3PL',
    CANCELED_FROM_3PL: 'لغو از 3PL',
    AWAITING_REVIEW: 'نتیجه نامشخص',
  };
  return status[value];
}

export function translatePostOrderStatus(value: PostOrderStatusType) {
  const status = {
    DONE: 'ارسال به پست',
    QUEUE: 'آماده ارسال',
    DRAFT: 'ارسال نشده',
  };
  return status[value];
}

export function translateOrderTransportationType(
  value: OrderTransportationType
) {
  const status = {
    NONE: 'بدون 3PL',
    ALOPEYK: 'الوپیک',
    LINK_EXPRESS: 'لینک اکسپرس',
    TAROFF: 'تعارف',
  };
  return status[value];
}

export function translateServiceType(value: ServiceType) {
  const status = {
    1: 'پیشتاز',
    2: 'سفارشی',
    3: 'ویژه',
  };
  return status[value];
}

export function translateParcelType(value: ParcelType) {
  const status = {
    1: 'پاکت پیشتاز',
    2: 'بسته پیشتاز',
    3: 'پاکت سفارشی',
    4: 'بسته سفارشی',
    5: 'مطبوع',
    6: 'کیسه M',
    10: 'امانت',
  };
  return status[value];
}

export function translateInsuranceType(value: InsuranceType) {
  const status = {
    1: 'بیمه عادی',
    2: 'وجه نقد',
    3: 'اوراق و اسناد بانکی',
    4: 'بار انبوه',
    5: 'سایر',
  };
  return status[value];
}

export function translateDeliveryType(value: 'BOX' | 'PALLET' | 'BULK') {
  const types = {
    BOX: 'کارتن',
    PALLET: 'پالت',
    BULK: 'فله',
  };
  return types[value];
}

export function translateTransactionType(
  value: 'CHARGE' | 'INCREASE' | 'DECREASE' | 'SETTLE'
) {
  const types = {
    CHARGE: 'شارژ',
    INCREASE: 'افزایش',
    DECREASE: 'کاهش',
    SETTLE: 'تسویه',
  };
  return types[value];
}

export function translateSendDeliveryType(
  value: 'COURIER' | 'POST' | 'EXPRESS_POST' | 'SPECIAL_POST' | 'VIP'
) {
  const types = {
    COURIER: 'پیک',
    POST: 'پست',
    EXPRESS_POST: 'پست پیشتاز',
    SPECIAL_POST: 'پست سفارشی',
    VIP: 'ارسال ویژه',
  };
  return types[value];
}

export function translateParcelsStatus(value: StatusParcels) {
  const status = {
    SUBMITTED: 'ایجاد شده',
    SHIPPED: ' ارسال شده',
    DELIVERED: ' تخلیه شده',
    CANCELLED: ' لغو شده',
    ASSIGNED: 'اختصاص داده شده',
    RETURNING: 'ریجکت شده',
    ARRIVED: 'به مقصد رسیده',
    UNLOADING: 'در حال بارگذاری',
    UNLOADED: 'بارگذاری شده',
    CONFLICTED: 'مغایرت',
    REGISTERED: 'رجیستر شده',
    LOCATED: 'جایگذاری شده',
    PICKED: 'برداشته شده',
    NOT_REGISTERED: 'ایجاد شده (رجیستر نشده)',
    CHECKED: 'بسته‌بندی شده',
    NORMAL: 'عادی',
    VIP: "ویژه",
  };
  return status[value];
}

export function translateInventoryItemStatus(value: ItemsStatusInventory) {
  const status = {
    PICKED: 'برداشته شده',
    CHECKED: 'بررسی شده',
    NOT_REGISTERED: 'ایجاد شده (رجیستر نشده)',
    REGISTERED: 'رجیستر شده',
    LOCATED: 'جایگذاری شده',
    NOT_LOCATED: 'جاگذاری نشده',
  };
  return status[value];
}

export function translateOrder3PLStatus(value: Order3PLStatusType) {
  const status = {
    REJECTED_BY_3PL: 'رد شده توسط 3PL',
    REGISTERED_IN_3PL: 'ثبت شده در 3PL',
    SEARCHING_COURIER: 'جستجوی پیک',
    SEARCHING_COURIER_EXPIRED: 'جستجوی پیک منقضی شد',
    COURIER_ACCEPTED: 'پیک درخواست شما را پذیرفت',
    DELIVERED_TO_3PL: 'تحویل داده شده به 3PL ',
    DELIVERED_TO_3PL_COURIER: 'تحویل داده شده به پیک 3PL ',
    DELIVERED: 'تحویل داده شده',
    NOT_DELIVERED: 'تحویل داده نشده',
    CANCELLED: 'لغو شده',
    REQUESTED_TO_CANCEL: 'درخواست شده برای لغو',
    NOT_REGISTERED: 'ایجاد شده (رجیستر نشده)',
    NONE: 'هیچکدام',
  };
  return status[value];
}

export function translateBundleStatus(value: StatusBundle) {
  const status = {
    ASSIGNED: 'اختصاص داده شده',
    CANCELLED: 'لغو شده',
    CREATED: 'بسته ایجاد شده',
    LOADED: 'بارگیری شده',
    PROCESS_FAILED: 'ناموفق',
    PROCESS_STARTED: 'راننده در مسیر مرکز',
    PROCESSED: 'راننده تحویل داده',
    VEHICLE_ARRIVED: 'ماشین به مرکز رسیده',
  };
  return status[value];
}
export function translateInvoiceStatus(value: StatusBundle) {
  const status = {
    CREATED: 'ایجاد شده',
    PAID: 'تسویه شده',
    NOT_PAID: 'تسویه نشده',
    CASH_PAID: 'تسویه دستی',
    CANCELED: 'لغو شده',
  };
  return status[value];
}

export function translateFleetType(value: FleetType) {
  const status = {
    PROPRIETARY: 'اختصاصی',
    THIRD_PARTY: 'عمومی',
  };
  return status[value];
}

export function translateEmploymentType(value: EmploymentType) {
  const status = {
    PART_TIME: 'پاره وقت',
    FULL_TIME: 'تمام وقت',
  };
  return status[value];
}

export function translateItemType(value: Type) {
  const status = {
    FROZEN: 'منجمد',
    FRUIT: 'میوه',
    GROCERY: 'خواربار',
    MEAT: 'گوشت',
    MASK: 'ماسک',
    PRODUCT: 'محصول',
  };
  return status[value];
}

export function translateDriversEmploymentStatus(value: EmploymentStatus) {
  const status = {
    REGISTERED: 'ثبت نام',
    OFF: 'غیر فعال',
    ACTIVE: 'فعال',
    SUSPENDED: 'معلق',
  };
  return status[value];
}

export function translateFleetStatus(value: FleetStatus) {
  const status = {
    SUSPENDED: 'غیر فعال',
    ACTIVE: 'فعال',
  };
  return status[value];
}

export function translateSettlementType(value: SettlementType) {
  const status = {
    WEEKLY: 'هفتگی',
    MONTHLY: 'ماهانه',
    DAILY: 'روزانه',
    YEARLY: 'سالانه',
  };
  return status[value];
}

export function translateVehicleType(value: VehicleType) {
  const status = {
    CAR: 'سواری',
    MOTORCYCLE: 'موتوری',
    PICKUPS: 'وانت',
    TRUCK: 'خاور',
    HEAVY_TRUCK: 'کامیون',
    AIRPLANE: 'هواپیما',
  };
  return status[value];
}

export function translateInventoryType(
  value: 'INBOUND' | 'PURCHASE' | 'OUTBOUND' | 'CURRENTLY' | 'OTHER'
) {
  const status = {
    INBOUND: 'ورودی',
    PURCHASE: 'سفارش',
    OUTBOUND: 'خروجی',
    CURRENTLY: 'موجودی فعلی',
    OTHER: 'نامشخص',
    null: 'نامشخص',
  };
  return status[value];
}

export function translateUserRoles(value: UserRole) {
  const role = {
    NONE: 'هیچکدام',
    RONAD_ADMIN: 'مدیر ارشد',
    PARTNER_ADMIN: 'ادمین شرکت',
    LOGISTICS_ADMIN: 'سرپرست لجستیک',
    WAREHOUSE_ADMIN: 'ادمین انبار',
    WAREHOUSE_OPERATOR: 'اپراتور انبار',
    WAREHOUSE_SUPERVISOR: 'سرپرست انبار',
    DRIVER: 'راننده',
    CENTER_ADMIN: 'ادمین مرکز',
    MARKETING_MANAGER: 'مدیر مارکتینگ',
    MARKETING_EXPERT: 'کارشناس مارکتینگ',
    OPERATIONS_MANAGER: 'مدیر عملیات',
    OPERATIONS_EXPERT: 'کارشناس عملیات',
    SUPPORT_MANAGER: 'مدیر پشتیبانی',
    SUPPORT_EXPERT: 'کارشناس پشتیبانی',
    AGENCY_ADMIN: 'نماینده',
    SELLER_ADMIN: 'ادمین فروشنده',
    FINANCIAL_SUPERVISOR: 'سرپرست مالی', 
    FINANCIAL_ADMIN: 'ادمین مالی', 
  };
  return role[value];
}

export function translateCenterStatus(value: StatusCenter) {
  const role = {
    ACTIVE: 'فعال',
    SUSPENDED: 'غیرفعال',
  };
  return role[value];
}

export function uintToString(uintArray: number[]) {
  const encodedString = String.fromCharCode.apply(null, uintArray),
    decodedString = decodeURIComponent(escape(encodedString));
  return JSON.parse(decodedString);
}

export const uuidv4 = () => {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

export function formaterPhoneNumber(string: string | undefined) {
  if (string && String(string).includes('+98'))
    return String(string).replace('+98', '0');
  if (string && String(string).includes('+'))
    return String(string).replace('+', '0');
  return string;
}

export function checkMatchMedia(media: string) {
  return window.matchMedia(media).matches;
}

export function fixNumbers(str: string) {
  const persianNumbers = [
      /۰/g,
      /۱/g,
      /۲/g,
      /۳/g,
      /۴/g,
      /۵/g,
      /۶/g,
      /۷/g,
      /۸/g,
      /۹/g,
    ],
    arabicNumbers = [
      /٠/g,
      /١/g,
      /٢/g,
      /٣/g,
      /٤/g,
      /٥/g,
      /٦/g,
      /٧/g,
      /٨/g,
      /٩/g,
    ];
  for (let i: any = 0; i < 10; i++) {
    str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
  }
  return str.trim();
}

export function fixToPersianNumbers(str: string) {
  const englishNumbers = [
      /0/g,
      /1/g,
      /2/g,
      /3/g,
      /4/g,
      /5/g,
      /6/g,
      /7/g,
      /8/g,
      /9/g,
    ],
    persianNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  for (let i: any = 0; i < persianNumbers.length; i++) {
    str = str.replace(englishNumbers[i], persianNumbers[i]);
  }
  return str.trim();
}

export function handleRedirectByRule(role: string) {
  switch (role) {
    case 'AGENCY_ADMIN':
      return (window.location.href = '/reports/current-orders');
    case 'CENTER_ADMIN':
      return (window.location.href = '/orders');
    case 'WAREHOUSE_SUPERVISOR':
      return (window.location.href = '/warehouses');
    case 'WAREHOUSE_ADMIN':
      return (window.location.href = '/warehouse-admin-orders');
    case 'WAREHOUSE_OPERATOR':
      return (window.location.href = '/parcels-warehouse-operator');
    case 'LOGISTICS_ADMIN':
      return (window.location.href = '/nonPost-orders');
    case 'SELLER_ADMIN':
      return (window.location.href = '/seller-orders');
    case 'EXCHANGE_ADMIN':
      return (window.location.href = '/bundles');
    default:
      return (window.location.href = '/orders');
  }
}
export function convertDatePersianToEnglish(date: any) {
  return date.replace(/[۰-۹]/g, (d: any) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
}

export function useQuery(locationHook: () => any) {
  return new URLSearchParams(locationHook().search);
}

export const handleErrorList = (
  errors: {[s: string]: unknown} | ArrayLike<unknown>
) => {
  const errorList: Array<unknown> = [];
  Object.entries(errors).map((el: Array<unknown>) => {
    // @ts-ignore
    if (el[1].length > 1) {
      // @ts-ignore
      el[1].forEach(item => {
        errorList.push({code: el[0], text: item});
      });
    } else {
      // @ts-ignore
      errorList.push({code: el[0], text: el[1][0]});
    }
  });
  return errorList;
};

export function translateFileUploadErrors(value: string) {
  const errorsList: {[key: string]: string} = {
    'order.customerMobileNumber.invalid': 'شماره همراه سفارش‌دهنده اشتباه است',
    'order.customerMobileNumber.invalid.size':
      'شماره همراه سفارش‌دهنده اشتباه است',
    'order.customerPhoneNumber.invalid': 'شماره تماس سفارش‌دهنده اشتباه است',
    'order.customerPhoneNumber.invalid.size':
      'شماره تماس سفارش‌دهنده اشتباه است',
    'order.customerAddress.invalid.size': 'آدرس سفارش‌دهنده اشتباه است',
    'order.customerAddress.invalid': 'آدرس سفارش‌دهنده اشتباه است',
    'order.customerProvince.invalid.size': 'استان سفارش‌دهنده اشتباه است',
    'order.customerCity.invalid.size': 'شهر سفارش‌دهنده اشتباه است',
    'order.customerZipCode.invalid': 'کد پستی سفارش‌دهنده اشتباه است',
    'order.customerZipCode.invalid.size': 'کد پستی سفارش‌دهنده اشتباه است',
    'order.customerNationalCode.invalid.size': 'کد ملی سفارش‌دهنده اشتباه است',
    'order.customerNationalCode.invalid': 'کد ملی سفارش‌دهنده اشتباه است',
    'order.customerName.invalid.size': 'نام سفارش‌دهنده اشتباه است',
    'order.trackingCode.invalid.size': 'کد پیگیری اشتباه است',
    'order.trackingCode.invalid': 'کد پیگیری اشتباه است',
    'order.trackingCode.exists': 'کد پیگیری اشتباه است',
    'order.deliveryDate.notExist': 'تاریخ تحویل اشتباه است',
    'order.deliveryStartTime.notExist': 'ساعت شروع تحویل اشتباه است',
    'order.deliveryEndTime.notExist': 'ساعت پایان تحویل اشتباه است',
    'orderItem.productCode.notProvided': 'کد کالا اشتباه است',
    'orderItem.productCode.notExists': 'کد کالا اشتباه است',
    'orderItem.variantCode.notProvided': 'کد تنوع کالای کالا اشتباه است',
    'product.categoryCode.invalid': 'کد دسته‌بندی کالا اشتباه است',
    'product.categoryCode.invalid.size': 'کد دسته‌بندی کالا اشتباه است',
    'product.name.invalid.size': 'نام کلا اشتباه است',
    'product.name.notExist': 'نام کلا اشتباه است',
    'product.code.invalid': 'کد کلا اشتباه است',
    'product.code.notExist': 'کد کلا اشتباه است',
    'product.code.invalid.size': 'کد کلا اشتباه است',
    'product.codingType.notExist': 'نوع کلا اشتباه است',
    'product.weight.invalid': 'وزن کلا اشتباه است',
    'product.length.invalid': 'طول کلا اشتباه است',
    'product.width.invalid': 'عرض کلا اشتباه است',
    'product.height.invalid': 'ارتفاع کلا اشتباه است',
    'product.shippingWeight.invalid': 'وزن حمل و نقل کلا اشتباه است',
    'product.shippingLength.invalid': 'طول حمل و نقل کلا اشتباه است',
    'product.shippingWidth.invalid': 'عرض حمل و نقل کلا اشتباه است',
    'product.shippingHeight.invalid': 'ارتفاع حمل و نقل کلا اشتباه است',
    'product.variant.seller.code.invalid': 'کد فروشنده کلا اشتباه است',
    'product.variant.seller.code.notExists': 'کد فروشنده کلا اشتباه است',
    'product.variant.provider.code.invalid': 'کد تامین‌کننده کلا اشتباه است',
    'product.variant.provider.code.notExists': 'کد تامین‌کننده کلا اشتباه است',
    'product.variant.code.must.filled': 'کد تنوع کالا اشتباه است',
    'orderItem.variantCode.notExists': 'کد تنوع کالا اشتباه است',
    'product.code.exist': 'این کد کالا قبلا ثبت شده است',
    'product.name.exist': 'این نام کالا قبلا ثبت شده است',
  };
  return errorsList[value];
}

export function sum(list: (number | string)[]) {
  let sum = 0 
  list.forEach(el => {
    if(el) {
      let num = typeof el === 'string' ? Number(el) : el
      sum += num
    }
  })
  return sum
}

/*
export const mergeVariants = (list: FeatureValues[]) => {
  let prevData = cloneDeep(list);

  function compareAndMerge(first: FeatureValues, second: FeatureValues) {
    if (first.featureCode === second.featureCode) {
      first.valueCode = second.valueCode = [].concat(first.valueCode, second.valueCode);
      return true;
    }
    return false;
  }

  function merge(items: FeatureValues[]) {
    return uniqWith(items, compareAndMerge);
  }

  return merge(prevData);
};
*/
